import { styled, keyframes } from '@mui/material/styles';
import { Box } from '@mui/material';

const typingBounce = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  30% {
    transform: translateY(-12px);
    opacity: 1;
  }
`;

const TypingContainer = styled(Box)(({ size }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    height: `${size * 2}px`,
}));

const TypingDot = styled('div')(({ size, color, delay }) => ({
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    backgroundColor: color,
    animation: `${typingBounce} 1.2s infinite ease-in-out`,
    animationDelay: `${delay}s`,
    display: 'inline-block',
    margin: '0 2px',
}));

const TypingIndicator = ({ size = 8, color = '#999', className = '', style = {} }) => {
    return (
        <TypingContainer className={`typing-indicator ${className}`} size={size} style={style}>
            <TypingDot size={size} color={color} delay={0} />
            <TypingDot size={size} color={color} delay={0.2} />
            <TypingDot size={size} color={color} delay={0.4} />
        </TypingContainer>
    );
};

export default TypingIndicator;
